import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { Gather } from "../../../gather/gather-typings";
import { TalentEmploymentAuthorizationRequest } from "../../../../typings";


@Injectable({
  providedIn: 'root'
})
export class TalentHappyPathDataService {
  private readonly _talent: BehaviorSubject<Talent> = new BehaviorSubject(null);
  readonly talent$ = this._talent.asObservable().pipe(distinctUntilChanged());

  private readonly _postingId: BehaviorSubject<number> = new BehaviorSubject(null);
  readonly postingId$ = this._postingId.asObservable().pipe(distinctUntilChanged());

  private readonly _orderId: BehaviorSubject<number> = new BehaviorSubject(null);
  readonly orderId$ = this._orderId.asObservable().pipe(distinctUntilChanged());

  private readonly _postingInfo: BehaviorSubject<PostingInfo> = new BehaviorSubject(null);
  readonly postingInfo$ = this._postingInfo.asObservable().pipe(distinctUntilChanged());

  private readonly _urlHasPostingId: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly urlHasPostingId$ = this._urlHasPostingId.asObservable().pipe(distinctUntilChanged());

  private readonly _resumeDetail: BehaviorSubject<ResumeDetail> = new BehaviorSubject(null);
  readonly resumeDetail$ = this._resumeDetail.asObservable().pipe(distinctUntilChanged());

  private readonly _doThisLaterEmailSent: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly doThisLaterEmailSent$ = this._doThisLaterEmailSent.asObservable().pipe(distinctUntilChanged());

  private readonly _marketingData: BehaviorSubject<MarketingTrackingInfo> = new BehaviorSubject(null);
  readonly marketingData$ = this._marketingData.asObservable().pipe(distinctUntilChanged());

  private readonly _isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly isAuthenticated$ = this._isAuthenticated.asObservable().pipe(distinctUntilChanged());

  private readonly _gather: BehaviorSubject<Gather> = new BehaviorSubject(null);
  readonly gather$ = this._gather.asObservable().pipe(distinctUntilChanged());

  private readonly _gatherToken: BehaviorSubject<string> = new BehaviorSubject(null);
  readonly gatherToken$ = this._gatherToken.asObservable().pipe(distinctUntilChanged());

  private readonly _goToVmsSub: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly goToVmsSub$ = this._goToVmsSub.asObservable().pipe(distinctUntilChanged());

  private readonly _candidateInviteLinkFrom: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  readonly candidateInviteLinkFrom$ = this._candidateInviteLinkFrom.asObservable().pipe(distinctUntilChanged());

  private readonly _isGeneralApplication: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly isGeneralApplication$ = this._isGeneralApplication.asObservable().pipe(distinctUntilChanged());


  private readonly _homeMarketCountryId: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  readonly homeMarketCountryId$ = this._homeMarketCountryId.asObservable().pipe(distinctUntilChanged());

  private readonly _employmentAuthorization: BehaviorSubject<TalentEmploymentAuthorizationRequest> = new BehaviorSubject<TalentEmploymentAuthorizationRequest>(null);



  // @ts-ignore
  set talent(talent: Talent) {
    this._talent.next(talent);
  }

  // @ts-ignore
  get talent(): Talent {
    return this._talent.getValue();
  }

  set postingId(postingId: number) {
    this._postingId.next(postingId);
  }

  // @ts-ignore
  get postingId(): number {
    return this._postingId.getValue();
  }

  set orderId(orderId: number) {
    this._orderId.next(orderId);
  }

  // @ts-ignore
  get orderId(): number {
    return this._orderId.getValue();
  }

  set postingInfo(postingInfo: PostingInfo) {
    this._postingInfo.next(postingInfo);
  }

  // @ts-ignore
  get postingInfo(): PostingInfo {
    return this._postingInfo.getValue();
  }

  set urlHasPostingId(urlHasPostingId: boolean) {
    this._urlHasPostingId.next(urlHasPostingId);
  }

  // @ts-ignore
  get urlHasPostingId(): boolean {
    return this._urlHasPostingId.getValue();
  }

  set resumeDetail(resumeDetail: ResumeDetail) {
    this._resumeDetail.next(resumeDetail);
  }

  // @ts-ignore
  get resumeDetail(): ResumeDetail {
    return this._resumeDetail.getValue();
  }

  set doThisLaterEmailSent(doThisLaterEmailSent: boolean) {
    this._doThisLaterEmailSent.next(doThisLaterEmailSent);
  }

  // @ts-ignore
  get doThisLaterEmailSent(): boolean {
    return this._doThisLaterEmailSent.getValue();
  }

  set marketingData(marketingData: MarketingTrackingInfo) {
    this._marketingData.next(marketingData);
  }

  // @ts-ignore
  get marketingData(): MarketingTrackingInfo {
    return this._marketingData.getValue();
  }

  set isAuthenticated(isAuthenticated: boolean) {
    this._isAuthenticated.next(isAuthenticated);
  }

  // @ts-ignore
  get isAuthenticated(): boolean {
    return this._isAuthenticated.getValue();
  }

  set gather(gather: Gather) {
    this._gather.next(gather);
  }

  get gather(): Gather {
    return this._gather.getValue();
  }

  set gatherToken(gatherToken: string) {
    this._gatherToken.next(gatherToken);
  }

  // @ts-ignore
  get gatherToken(): string {
    return this._gatherToken.getValue();
  }

  set goToVmsSub(goToVmsSub: boolean) {
    this._goToVmsSub.next(goToVmsSub);
  }

  get goToVmsSub(): boolean {
    return this._goToVmsSub.getValue();
  }

  set candidateInviteLinkFrom(candidateInviteLinkFrom: string) {
    this._candidateInviteLinkFrom.next(candidateInviteLinkFrom);
  }

  get candidateInviteLinkFrom(): string {
    return this._candidateInviteLinkFrom.getValue();
  }

  set isGeneralApplication(isGeneralApplication: boolean) {
    this._isGeneralApplication.next(isGeneralApplication);
  }

  get isGeneralApplication(): boolean {
    return this._isGeneralApplication.getValue();
  }

  set homeMarketCountryId(homeMarketCountryId: number) {
    this._homeMarketCountryId.next(homeMarketCountryId);
  }

  get homeMarketCountryId(): number {
    return this._homeMarketCountryId.getValue();
  }

  set employmentAuthorization(employmentAuthorization: TalentEmploymentAuthorizationRequest) {
    this._employmentAuthorization.next(employmentAuthorization);
  }

  get employmentAuthorization(): TalentEmploymentAuthorizationRequest {
    return this._employmentAuthorization.getValue();
  }

}
